export const wizardStepsUnknown = Object.freeze({
  DIMENSIONS: 'Maße',
  NOTE: 'Notiz',
});
